import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import TaskQueueItemRow from "./TaskQueueItemRow";
import { getTaskFilters } from "./TaskQueueStore";
import { useStatusPalette } from "../../../utils/statusColors";

function FilterChip({ label, active, onClick }) {
  const _sp = useStatusPalette();
  return (
    <Box
      onClick={onClick}
      sx={{
        px: 1,
        py: "5px",
        borderRadius: "6px",
        border: "1px solid",
        borderColor: active ? _sp.blue.border : "divider",
        backgroundColor: active ? _sp.blue.bg : "background.paper",
        color: active ? _sp.blue.color : "text.secondary",
        fontSize: "11px",
        fontWeight: 600,
        cursor: "pointer",
        userSelect: "none",
        whiteSpace: "nowrap",
        lineHeight: 1,
        transition: "all 120ms ease",
        "&:hover": {
          borderColor: active ? _sp.blue.border : "text.disabled",
          backgroundColor: active ? _sp.blue.bg : "action.hover",
        },
      }}
    >
      {label}
    </Box>
  );
}

export default function TaskQueueList({
  loading,
  tasks,
  allTasks,
  selectedTaskId,
  activeFilter,
  onFilterChange,
  onSelectTask,
}) {
  const filters = getTaskFilters();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: 0, flex: 1 }}>
      <Box
        sx={{
          px: 1.25,
          py: 1,
          display: "flex",
          alignItems: "center",
          gap: 0.5,
          flexWrap: "wrap",
          borderBottom: "1px solid",
          borderColor: "divider",
        }}
      >
        {filters.map((f) => (
          <FilterChip
            key={f.key}
            label={f.label}
            active={activeFilter === f.key}
            onClick={() => onFilterChange(f.key)}
          />
        ))}
      </Box>

      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          overflowY: "auto",
          overflowX: "hidden",
          p: 1,
          display: "flex",
          flexDirection: "column",
          gap: 0.75,
        }}
      >
        {loading ? (
          <Box sx={{ py: 4, display: "flex", justifyContent: "center" }}>
            <CircularProgress size={18} thickness={5} sx={{ color: "text.disabled" }} />
          </Box>
        ) : tasks.length === 0 ? (
          <Box sx={{ py: 3, display: "flex", justifyContent: "center" }}>
            <Typography sx={{ fontSize: "12px", color: "text.disabled" }}>
              No tasks match this filter.
            </Typography>
          </Box>
        ) : (
          tasks.map((task) => {
            const globalIndex = (allTasks || tasks).findIndex((t) => t.taskId === task.taskId);
            return (
              <TaskQueueItemRow
                key={task.taskId || `${task.title}-${task.createdAt}`}
                task={task}
                index={globalIndex >= 0 ? globalIndex : undefined}
                selected={selectedTaskId === task.taskId}
                onClick={() => onSelectTask(task)}
              />
            );
          })
        )}
      </Box>
    </Box>
  );
}
